import HourglassBottom from "@mui/icons-material/HourglassBottom";
import CheckBox from "@mui/icons-material/CheckBox";
import Block from "@mui/icons-material/Block";
import { useIntl } from "react-intl";
import { SkuUserAgreementInfo } from "services/KnowfullyAdminClient";
import { UserAgreementStatusId } from "types/common-types";

export default function UserAgreementStatusView({
  value,
}: {
  value: SkuUserAgreementInfo;
}) {
  const { formatMessage: t } = useIntl();
  switch (value.statusId?.toLowerCase()) {
    case UserAgreementStatusId.Accepted:
      return <CheckBox color="success" titleAccess={t({ id: "accepted" })} />;
    case UserAgreementStatusId.Pending:
      return <HourglassBottom titleAccess={t({ id: "pendingLabel" })} />;
    case UserAgreementStatusId.Rejected:
      return <Block color="error" titleAccess={t({ id: "rejected" })} />;
    case UserAgreementStatusId.Cancelled:
      return <Block color="error" titleAccess={t({ id: "cancelled" })} />;
  }

  return null;
}
